import ExperiencesSection from "./components/PageSection/ExperiencesSection";
import HobbyistSection from "./components/PageSection/HobbyistSection";
import IntroSection from "./components/PageSection/IntroSection";
import TimelineSection from "./components/PageSection/TimelineSection";
import AdventureSection from "./components/PageSection/AdventureSection";
import ContactSection from "./components/PageSection/ContactSection";
import WorkExperienceSection from "./components/PageSection/WorkExperienceSection";
// import ProjectsSection from "./components/PageSection/ProjectsSection";
import EducationAwardsSection from "./components/PageSection/EducationAwardsSection";
import Navbar from "./components/Navbar";
import { useRef } from "react";
import { easeInOut, useScroll, useTransform } from "motion/react";
import { Analytics } from "@vercel/analytics/react";
// import LocomotiveScroll from "locomotive-scroll";

export function App() {
  // Fade in navbar
  const workExpContainer = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: workExpContainer, offset: ["start start", "end start"] });
  const navbarOpacity = useTransform(scrollYProgress, [0.9, 1], [0, 1], { ease: easeInOut });

  // Smooth scrolling
  // new LocomotiveScroll({
  //   lenisOptions: {
  //     smoothWheel: true,
  //     wheelMultiplier: 1.5,
  //     touchMultiplier: 1,
  //   },
  // });

  return (
    <div>
      <IntroSection />
      <HobbyistSection />
      <TimelineSection />
      <ExperiencesSection />
      <AdventureSection />
      <div className='relative'>
        <Navbar className='sticky bg-base-100/50 shadow-lg glass' style={{ opacity: navbarOpacity }} />
        <ContactSection ref={workExpContainer} />
        <WorkExperienceSection />
        <EducationAwardsSection />
      </div>
      <Analytics />
    </div>
  );
}

export default App;
